import React, { Fragment } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import cn from 'classnames';
import { OrderedSet, Seq } from 'immutable';

import UserDevice from 'services/user-device';
import GroupOfOdds from './GroupOfOdds';

import './body.scss';

interface Props {
    betslipOddIdsGroup: Seq.Indexed<[string, OrderedSet<string>]>;
}

const Body: React.FC<Props> = ({ betslipOddIdsGroup }) => {
    const withCustomScrollbars = !UserDevice.getInstance()?.isDeviceMobile();
    const Wrapper = withCustomScrollbars ? Scrollbars : Fragment;

    const groupSize = betslipOddIdsGroup.count();

    return (
        <div
            styleName={cn('container', {
                ['with-custom-scrollbar']: withCustomScrollbars,
            })}
            className="__app-Body-container"
        >
            <Wrapper>
                {betslipOddIdsGroup.map(
                    ([matchId, groupBetslipOddIds], idx) => (
                        <GroupOfOdds
                            key={`${matchId}${groupBetslipOddIds.first()}`}
                            betslipOddIds={groupBetslipOddIds}
                            isLastGroup={groupSize === idx + 1}
                        />
                    )
                )}
            </Wrapper>
        </div>
    );
};

export default React.memo(Body);
